import Requisition from '@/page/delivery/Requisition';
import RequistionAdd from '@/page/delivery/RequistionAdd';
import RequisitionDetail from '@/page/delivery/RequistionDetail';
import Transferring from '@/page/delivery/Transferring';
import TransferringAdd from '@/page/delivery/TransferringAdd';
import TransferringSummery from '@/page/delivery/TransferringSummery';
import TransferringDetail from '@/page/delivery/TransferringDetail';
import Deliver from '@/page/delivery/Deliver';
import DeliverAdd from '@/page/delivery/DeliverAdd';
import DeliverDetail from '@/page/delivery/DeliverDetail';
import Query from '@/page/delivery/Query';
import DdSetting from '@/page/delivery/dd/Setting';
import DdRecord from '@/page/delivery/dd/Record';
import UuSetting from '@/page/delivery/uu/Setting';
import UuRecord from '@/page/delivery/uu/Record';
import Difference from '@/page/delivery/Difference'
import DifferenceAdd from '@/page/delivery/DifferenceAdd'
import DifferenceDetail from '@/page/delivery/DifferenceDetail'

export const delivery = [
  {
    path: '/delivery/uu/setting',
    name: 'uuSetting',
    component: UuSetting,
    meta: {
      requireAuth: true,
      title: 'UU跑腿'
    }
  },
  {
    path: '/delivery/uu/record',
    name: 'uuRecord',
    component: UuRecord,
    meta: {
      requireAuth: true,
      title: 'UU跑腿记录'
    }
  },
  {
    path: '/delivery/dd/setting',
    name: 'ddSetting',
    component: DdSetting,
    meta: {
      requireAuth: true,
      title: '达达配送'
    }
  },
  {
    path: '/delivery/dd/record',
    name: 'ddRecord',
    component: DdRecord,
    meta: {
      requireAuth: true,
      title: '达达配送记录'
    }
  },
  {
    path: '/delivery/requisition',
    name: 'requisition',
    component: Requisition,
    meta: {
      requireAuth: true,
      title: '要货单'
    }
  },
  {
    path: '/delivery/requisition/add',
    name: 'requisitionAdd',
    component: RequistionAdd,
    meta: {
      requireAuth: true,
      title: '要货单'
    }
  },
  {
    path: '/delivery/requisition/detail',
    name: 'requisitionDetail',
    component: RequisitionDetail,
    meta: {
      requireAuth: true,
      title: '要货单'
    }
  },
  {
    path: '/delivery/transferring',
    name: 'transferring',
    component: Transferring,
    meta: {
      requireAuth: true,
      title: '调拨出库单'
    }
  },
  {
    path: '/delivery/transferring/add',
    name: 'transferringAdd',
    component: TransferringAdd,
    meta: {
      requireAuth: true,
      title: '调拨出库单'
    }
  },
  {
    path: '/delivery/transferring/summery',
    name: 'TransferringSummery',
    component: TransferringSummery,
    meta: {
      requireAuth: true,
      title: '调拨出库单'
    }
  },
  {
    path: '/delivery/transferring/detail',
    name: 'transferringDetail',
    component: TransferringDetail,
    meta: {
      requireAuth: true,
      title: '调拨出库单详情'
    }
  },
  {
    path: '/delivery/deliver',
    name: 'deliver',
    component: Deliver,
    meta: {
      requireAuth: true,
      title: '调拨入库单'
    }
  },
  {
    path: '/delivery/deliver/add',
    name: 'deliverAdd',
    component: DeliverAdd,
    meta: {
      requireAuth: true,
      title: '调拨入库单'
    }
  },
  {
    path: '/delivery/deliver/detail',
    name: 'deliverDetail',
    component: DeliverDetail,
    meta: {
      requireAuth: true,
      title: '调拨入库单详情'
    }
  },
  {
    path: '/delivery/difference',
    name: 'Difference',
    component: Difference,
    meta: {
      requireAuth: true,
      title: '调拨差异单'
    }
  },
  {
    path: '/delivery/difference/add',
    name: 'DifferenceAdd',
    component: DifferenceAdd,
    meta: {
      requireAuth: true,
      title: '调拨差异单'
    }
  },
  {
    path: '/delivery/difference/detail',
    name: 'DifferenceDetail',
    component: DifferenceDetail,
    meta: {
      requireAuth: true,
      title: '调拨差异单详情'
    }
  },
  {
    path: '/delivery/query',
    name: 'query',
    component: Query,
    meta: {
      requireAuth: true,
      title: '调拨查询'
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/delivery.route.js